module.exports = __webpack_public_path__ + "static/media/gas_entry.fd5ebd23.svg";